const style = theme => ({
  root: {
    //minHeight: 150,
    width: '100%',
    height: '100%',
  },
  usageModeSelectRoot: {
    height: '100%',
  },
  usageModeSelectContent: {
    height: 'calc(100% - 70px)',
    overflowX: 'hidden',
    [theme.breakpoints.down('sm')]: {
      height: 'calc(100% - 60px)',
    },
  },
  headerNavigation: {},
  actionButtons: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
      gap: '8px',
    },
  },
  topBar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: '12px',
      alignItems: 'stretch',
    },
  },
  headerNavigationRight: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
      gap: '8px',
    },
    //marginTop: theme.spacing(2),
  },
  table: {
    //width: '100%',
    // marginTop: theme.spacing(2),
    backgroundColor: '#f4f6f8',
    borderCollapse: 'separate',
    padding: 16,
    borderRadius: 16,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: 12,
      borderRadius: 12,
    },
    [theme.breakpoints.down('xs')]: {
      padding: 8,
      borderRadius: 8,
    },
  },
  tableContainer: {
    width: '100%',
    overflowX: 'auto',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      '& table': {
        minWidth: '600px', // Ensure minimum width for readability
      },
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
      '& table': {
        minWidth: '500px', // Smaller minimum width for very small screens
      },
    },
  },
  gridTable: {
    width: '100%',
  },
  filterButtonHolder: {
    margin: 'auto 8px',
    [theme.breakpoints.down('sm')]: {
      margin: '4px',
    },
  },
  filterButton: {
    cursor: 'pointer',
    border: '1px solid #ced4da',
    display: 'inline-flex',
    padding: '11px 14px',
    position: 'relative',
    boxSizing: 'border-box',
    alignItems: 'center',
    borderRadius: 4,
    backgroundColor: 'white',
    height: 56,
    [theme.breakpoints.down('sm')]: {
      padding: '8px 12px',
      height: 48,
    },
    [theme.breakpoints.down('xs')]: {
      padding: '6px 10px',
      height: 40,
    },
  },
})

export default style
